/** @description 自定义节点 全局规则 */

import { TableItemData } from '@/components/index';
import { Item, nodeStyle } from '@/components/node-default'
import Container from './container';
import { DropResult } from './box';
import { useDispatch } from 'umi';
import React from 'react';
import { SWITCH_EVENT } from './node-form';

function MyNode({ data, selected }: { data: TableItemData, selected: boolean }) {
  const dispatch = useDispatch();

  const onDrop = (item: DropResult) => {
    dispatch({
      type: 'open/handleCopyItem',
      payload: { nodeId: data.id, ...item }
    })
  }

  let borderColor = '#777';
  if (selected) borderColor = '#E0144C';

  return <Container id={data.id} onDrop={onDrop}>
    <div style={{ ...nodeStyle, borderColor, background: 'rgba(21, 195, 210, 0.4)' }}>
      <div style={{ fontSize: 12, fontWeight: 600 }}>{data.label}</div>
      {Item(data.isOnEnter, data.onEnter, SWITCH_EVENT.初入, data.label, data.id)}
      {Item(data.isOnIdle, data.onIdle, SWITCH_EVENT.挽留, data.label, data.id)}
      {Item(data.isOnReceive, data.onReceive, SWITCH_EVENT.匹配, data.label, data.id)}
      <div style={globalRemindStyle}>全局规则</div>
    </div>
  </Container>;
}

export default React.memo(MyNode);

const globalRemindStyle = {
  fontSize: 10,
  width: '100%',
  display: 'flex',
  justifyContent: 'flex-end',
  color: '#fff',
  fontStyle: 'italic',
}
